import MessagesWidget from "views/logic/widgets/MessagesWidget";
import { updateWidgetConfig } from "views/logic/slices/widgetActions";
const AddToTableActionHandler = ({ field, contexts: { widget } }) => (dispatch) => {
  const newFields = [].concat(widget.config.fields, [field]);
  const newConfig = widget.config.toBuilder().fields(newFields).build();
  return dispatch(updateWidgetConfig(widget.id, newConfig));
};
const isEnabled = ({ contexts: { widget }, field }) => {
  if (MessagesWidget.isMessagesWidget(widget) && widget.config) {
    const fields = widget.config.fields || [];
    return !fields.includes(field);
  }
  return false;
};
const isHidden = ({ contexts: { widget } }) => !widget;
AddToTableActionHandler.isEnabled = isEnabled;
AddToTableActionHandler.isHidden = isHidden;
export default AddToTableActionHandler;
